
import {
    BUILDING_UPGRADE_REQUEST,
    BUILDING_UPGRADE_SUCCESS,
    BUILDING_UPGRADE_ERROR,
    BUILDING_UPGRADE_SHOW_HIGHLIGHT,
    BUILDING_UPGRADE_HIDE_HIGHLIGHT,
    BUILDING_UPGRADE_CONFIRMATION_OPEN,
    BUILDING_UPGRADE_CONFIRMATION_CLOSE,
} from 'state/actions/building_upgrade'


const initialState = {
    submitting: false,
    submitted: false,
    errorMessage: '',
    highlighted: false,
    confirmationOpened: false,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case BUILDING_UPGRADE_REQUEST: {
        return {
            ...state,
            submitted: false,
            submitting: true,
            errorMessage: '',
        }
    }
    case BUILDING_UPGRADE_SUCCESS: {
        return {
            ...state,
            submitted: true,
            submitting: false,
        }
    }
    case BUILDING_UPGRADE_ERROR: {
        return {
            ...state,
            submitted: false,
            submitting: false,
            errorMessage: action.payload.errorMessage,
            confirmationOpened: false,
        }
    }
    case BUILDING_UPGRADE_SHOW_HIGHLIGHT: {
        return {
            ...state,
            highlighted: true,
        }
    }
    case BUILDING_UPGRADE_HIDE_HIGHLIGHT: {
        return {
            ...state,
            highlighted: false,
        }
    }
    case BUILDING_UPGRADE_CONFIRMATION_OPEN: {
        return {
            ...state,
            confirmationOpened: true,
        }
    }
    case BUILDING_UPGRADE_CONFIRMATION_CLOSE: {
        return {
            ...state,
            submitted: false,
            confirmationOpened: false,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/building_upgrade.js